/**
 * @summary main store mutations constants
 * @author Dominik Haas-Artho
 *
 * Created at     : 2019-10-23 16:34:51
 * Last modified  : 2020-09-01 14:07:48
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

export const GET_CONFIG = 'GET_CONFIG';
export const GET_CONFIG_SUCCESS = 'GET_CONFIG_SUCCESS';
export const GET_CONFIG_ERROR = 'GET_CONFIG_ERROR';

export const GET_ABOUT = 'GET_ABOUT';
export const GET_ABOUT_SUCCESS = 'GET_ABOUT_SUCCESS';
export const GET_ABOUT_ERROR = 'GET_ABOUT_ERROR';

export const GET_S3_CONTENT = 'GET_S3_CONTENT';
export const GET_S3_CONTENT_SUCCESS = 'GET_S3_CONTENT_SUCCESS';
export const GET_S3_CONTENT_ERROR = 'GET_S3_CONTENT_ERROR';

export const USER_BUCKET_URL = 'USER_BUCKET_URL';
export const USER_BUCKET_URL_SUCCESS = 'USER_BUCKET_URL_SUCCESS';
export const USER_BUCKET_URL_ERROR = 'USER_BUCKET_URL_ERROR';
